export default {
  barTitle: 'Cookies',
  barDescription:
    'Utilizziamo cookie propri e di terzi per mostrarvi la pagina web e capire come la utilizzate, nonché per migliorare i servizi che offriamo. Se continuate a navigare, consideriamo che accettate il loro utilizzo.',
  acceptAll: 'Accetta tutto',
  declineAll: 'Cancella tutto',
  manageCookies: 'Gestisci i cookie',
  unsaved: 'Ci sono impostazioni non salvate',
  close: 'Chiudi',
  save: 'Salva',
  necessary: 'Cookie necessari',
  optional: 'Cookie opzionali',
  functional: 'Cookie funzionali',
  blockedIframe: 'Per vedere questo, si prega di abilitare i cookie funzionali',
  here: 'qui'
}
